import { useNavigate, Link } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PortalLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <header className="sticky top-0 z-40 bg-white border-b border-[#E5E7EB]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 flex h-16 items-center justify-between">
          <Logo to="/portal" />
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-slate-500">{user?.name}</span>
            <Button
              data-testid="portal-request-btn"
              onClick={() => navigate("/request-fuel")}
              className="bg-[#E5B800] hover:bg-[#CCA300] text-black font-semibold h-9"
            >
              New Request
            </Button>
            <button
              data-testid="portal-logout-btn"
              onClick={async () => { await logout(); navigate("/"); }}
              className="p-2 text-slate-500 hover:text-[#0A4F35]"
              aria-label="Sign out"
            >
              <SignOut size={22} />
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
